import {
  DataGrid,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarQuickFilter,
  GridToolbarContainer,
  ptBR,
} from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import Box from "@mui/material/Box";

export const DataGridDetails = ({
  loadingData,
  data,
  columns,
  position,
  trackerRelationshipId,
}) => {
  const [rows, setRows] = useState(data);
  const [hiddenColumns, setHiddenColumns] = useState({});
  const [pageSize, setPageSize] = useState(5);

  useEffect(() => {
    setRows(data);
  }, [data]);

  const processRowUpdate = (newRow) => { };

  const handleColumnVisibilityChange = (columns) => {
    setHiddenColumns(columns);
  };

  const handleRowClick = (params, event, details) => {
    const lat = params.row["latitude"];
    const long = params.row["longitude"];
    const plate = params.row["vehiclePlate"];

    position({ latitude: lat, longitude: long }, plate);
    trackerRelationshipId(params.row["trackerRelationshipId"]);
  };

  const CustomToolbar = () => {
    return (
      <GridToolbarContainer>
        <Grid
          container
          spacing={1}
          alignItems="center"
          justifyContent="flex-start"
        >
          <Grid
            item
            xs={3}
            sm={2}
            md={2}
            lg={2}
            xl={1}
            style={{ display: "flex", justifyContent: "flex-start" }}
          >
            <GridToolbarColumnsButton
              sx={{
                color: "#414141",
                fontSize: "15px",
                marginLeft: "20px",
                zIndex: 3,
              }}
            />
          </Grid>

          <Grid
            item
            xs={2}
            sm={2}
            md={2}
            lg={2}
            xl={1}
            style={{ display: "flex", justifyContent: "flex-start" }}
          >
            <GridToolbarFilterButton
              title="Selecionar Filtros"
              sx={{
                color: "#414141",
                fontSize: "15px",
                marginLeft: "10px",
                zIndex: 3,
              }}
              size="20px"
            />
          </Grid>

          <Grid
            item
            xs={2}
            sm={2}
            md={2}
            lg={2}
            xl={2}
            style={{ display: "flex", justifyContent: "flex-start" }}
          >
            <GridToolbarQuickFilter
              sx={{
                color: "#414141",
                fontSize: "15px",
                marginLeft: "20px",
                zIndex: 3,
              }}
            />
          </Grid>
        </Grid>
      </GridToolbarContainer>
    );
  };

  const configBox = {
    height: "36vh",
    width: "100%",
    marginLeft: "-10px",
    "& .dataGrid-true": {
      bgcolor: "#eeeeee",
    },
    "& .dataGrid-false": {
      bgcolor: "#ffffff",
    },
    "& .super-app-theme--header": {
      backgroundColor: "rgba(65,65,65,0.8)",
    },
  };

  const configDataGridStyle = {
    border: "none",
    height: "100%",
    width: "100%",
    marginTop: "-40px",
    ".highlight": {
      bgcolor: "rgba(166,166,166,0.5)",
      "&:hover": {
        bgcolor: "darkgrey",
      },
    },
    "& .MuiDataGrid-footerContainer": {
      height: "50px",
      marginRight: "35px",
      minHeight: "50px",
      border: "none",
    },
    "& .MuiDataGrid-row.Mui-selected": {
      backgroundColor: "rgb(124,124,124) !important ",
      color: "white !important  ",
    },
    "& .MuiDataGrid-row": {
      cursor: "pointer",
    },
  };

  const configComponentsProps = {
    panel: {
      sx: {
        "& .MuiTypography-root": {
          color: "#2f3237",
          fontSize: 12,
        },

        "& .MuiSvgIcon-root": {
          color: "#2f3237",
          marginTop: "-1px",
        },
        "& .batteryTrunk": {
          marginTop: "-1px",
          color: "#2f3237",
        },
        "& .svg-inline--fa": {
          marginTop: "-1px",
          color: "#2f3237",
        },
        "& .MuiDataGrid-columnsPanelRow:first-of-type": {
          display: "none",
        },
        "& .MuiDataGrid-panelFooter button:first-of-type": {
          display: "none",
        },
      },
    },
    footer: {
      sx: {
        "& .MuiTablePagination-root": {
          minHeight: "30px",
          height: "30px",
        },
        "& .MuiTablePagination-toolbar": {
          marginTop: "5px",
          minHeight: "10px",
          height: "10px",
        },
        "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows":
        {
          fontSize: "12px",
          margin: 0,
          color: "black !important",
        },
        "& .MuiTablePagination-select": {
          margin: 0,
          fontSize: "12px",
        },
        "& .MuiTablePagination-actions": {
          margin: 0,
        },
        "& .css-rtrcn9-MuiTablePagination-root:last-child": {
          display: "contents",
        },
      },
    },
  };

  return (
    <Box sx={configBox}>
      <DataGrid
        loading={loadingData}
        localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
        components={{
          Toolbar: CustomToolbar,
        }}
        rows={rows}
        columns={columns}
        processRowUpdate={processRowUpdate}
        disableColumnMenu
        pageSize={pageSize}
        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
        rowsPerPageOptions={[5, 10, 20, 50, 70, 100]}
        experimentalFeatures={{ newEditingApi: true }}
        onRowClick={handleRowClick}
        rowHeight={25}
        getRowClassName={(params) => {
          return params.row.id % 2 === 0 ? "highlight" : "white";
        }}
        sx={configDataGridStyle}
        columnVisibilityModel={hiddenColumns}
        onColumnVisibilityModelChange={(col) =>
          handleColumnVisibilityChange(col)
        }
        componentsProps={configComponentsProps}
      />
    </Box>
  );
};
